

import React from "react";

export const MailIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
    className = "w-3 h-3 text-gray-80",
    ...props
}) => {
    return (

        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className={className}  {...props}>
            <path d="M15 3H3C2.17157 3 1.5 3.67157 1.5 4.5V13.5C1.5 14.3284 2.17157 15 3 15H15C15.8284 15 16.5 14.3284 16.5 13.5V4.5C16.5 3.67157 15.8284 3 15 3Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16.5 5.25L9.7725 9.525C9.54095 9.67007 9.27324 9.74701 9 9.74701C8.72676 9.74701 8.45905 9.67007 8.2275 9.525L1.5 5.25" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};


